import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Category from '@/pages/category/page';
import ComicDetail from '@/pages/comic/page';
import ReadPage from '@/pages/read/page';
import About from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/category/:catId?', element: <Category /> },
      { path: '/comic/:id', element: <ComicDetail /> },
      { path: '/read/:id/:num', element: <ReadPage /> },
      { path: '/about', element: <About /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;